import TextInput from "../../components/textInput/TextInput";
import {useAuth} from "../../providers/AuthProvider";
import {
    Box,
    Button,
    Flex,
    Link,
    Text,
    Stack,
    Image
} from '@chakra-ui/react';
import * as Yup from 'yup';
import bg from '../../assets/images/bg.png'
import logo from '../../assets/images/logo.svg'
import {Formik, Form} from 'formik';
import {Navigate, useNavigate} from "react-router-dom";

const LoginPage = () => {
    const {login, user, loginError} = useAuth();
    const navigate = useNavigate();

    if(user) {
        return <Navigate to={"/"} replace  />
    }

    const handleSubmit = (values, {setSubmitting}) => {
        login(values.email, values.password);
    }

    const handleNavigate = (route) => {
        navigate(route);
    }

    const validationSchema = Yup.object({
        email: Yup.string()
            .email('Niepoprawny format email')
            .required('Email jest wymagany'),
        password: Yup.string()
            .min(6, 'Hasło musi zawierać co najmniej 6 znaków')
            .required('Hasło jest wymagane'),
    });

    return (
        <Flex
            bgImg={bg} bgSize="cover" bgPosition="center"
            w="100%" minH="100vh"
            align="center" justify="center"
            px={{base: 4, sm: 6}}>

            <Box maxW="lg" w="full" bg="transparent">
                <Stack spacing={6} align="center" mb={8}>
                    <Image src={logo} w={116}/>
                    <Text
                        textAlign="center"
                        lineHeight={{base: '16px', sm: 'sm'}}
                        fontFamily="Poppins"
                        fontWeight="bold"
                        fontSize={{ base: 20, sm: 24 }}
                        color="black"
                    >
                        Zaloguj się
                    </Text>
                </Stack>

                <Formik
                    initialValues={{email: '', password: ''}}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({isSubmitting, errors, touched}) => (
                        <Form>
                            <Stack spacing={4}>
                                <TextInput
                                    label="Adres e-mail"
                                    name="email"
                                    type="email"
                                    placeholder="Wprowadź adres e-mail"
                                    errors={errors}
                                    touched={touched}
                                />

                                <TextInput
                                    label="Hasło"
                                    name="password"
                                    type="password"
                                    placeholder="Wprowadź hasło"
                                    errors={errors}
                                    touched={touched}
                                />
                            </Stack>

                            {loginError && (
                                <Text color="red.500" textAlign="center" mt={4}>
                                    {loginError}
                                </Text>
                            )}

                            <Box display="flex" flexDirection="column" alignItems="center" mt={8}>
                                <Button
                                    display={"flex"}
                                    type="submit"
                                    justifySelf="center"
                                    isLoading={isSubmitting &&!loginError}
                                    bg="#0A4725"
                                    w={'159px'}
                                    h={'50px'}
                                    borderRadius={0}
                                    fontFamily={'Poppins'} fontWeight={'600'} fontSize={'16px'}
                                    color="white"
                                    gap={'10px'}
                                    _hover={{ bg: "#1A7743" }}
                                >
                                    Zaloguj się
                                    <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0H3.58481L8 5L3.58481 10H0L4.43544 5L0 0Z" fill="white"/>
                                    </svg>
                                </Button>
                            </Box>
                        </Form>
                    )}
                </Formik>
            </Box>
        </Flex>
    )
}

export default LoginPage;
